import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsCtx = createContext({});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    site_name: "Kyouka Reimei TL",
    tagline: "Unlock the Dawn of Translated Worlds",
    elite_price: 10000,
    hardcore_price: 25000,
    god_tier_price: 500000,
    membership_days: 30,
    contact_email: "",
    about_text: "",
    payment_methods: {},
    supporter_hall_enabled: true,
    leaderboard_enabled: true,
  });

  const reload = async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings(data);
    } catch (e) {
      console.error("Failed to load public settings:", e);
    }
  };

  useEffect(() => { reload(); }, []);

  return (
    <SettingsCtx.Provider value={{ settings, reload }}>{children}</SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);
